// extracted by mini-css-extract-plugin
module.exports = {"loading-page":"loading-page_loading-page__3dphG","spinner":"loading-page_spinner__1Qy6f"};